export default function formatCurrency(value: number) {
  return Intl.NumberFormat('pt-BR', { currency: 'BRL', style: 'currency' })
    .format(value)
    .replace('\xa0', '');
}
